define('models/welcome_message',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'welcome-messages/' + this.id + '/' ) :
                ( App.Config.apiBase + 'welcome-messages/' );
        },

        defaults: function () {
            return {
                target: 0,
                is_activated: true,
                message_body: ''
            };
        }
    });
});
